module.exports = __webpack_public_path__ + "static/media/requestIconSuccess.ffb86990.svg";